import pxToRem from "../functions/pxToRem";
import colors from "../base/colors";
import boxShadows from "../base/boxShadows";
import borders from "../base/borders";

const { light } = colors;
const { lg } = boxShadows;
const { borderRadius } = borders;

export default {
  styleOverrides: {
    paper: {
      backgroundColor: light.main,
      boxShadow: lg,
      padding: pxToRem(0),
      borderRadius: borderRadius.lg,
    },
  },
};
